module.exports = __webpack_public_path__ + "img/Kauflandde.09f2915e.jpg";